import get from 'lodash/get';
import each from 'lodash/each';
import noop from 'lodash/noop';
import { Subject } from 'rxjs';

export const subscriptions = {};

export function eventGetterSafe(name) {
  return get(subscriptions, name, {
    unsubscribe() {
      Logger.warn('No event found with name:', name, 'to unsubscribe. Possible regression.');
    },
    next() {
      Logger.warn('No event found with name:', name, 'to call. Possible regression.');
    },
  });
}

export function subscribe(name, success) {
  subscriptions[name] = subscriptions[name] && !subscriptions[name].closed ? subscriptions[name] : new Subject();
  return (
    subscriptions[name].subscribe &&
    subscriptions[name].subscribe(
      (...args) => {
        // eslint-disable-next-line prefer-spread
        success.apply(null, args[0]);
      },
      (err) => {
        Logger.error(`rx service error: ${err}`);
      },
      () => {
        // eslint-disable-next-line no-unused-expressions
        this.unsubscribe && this.unsubscribe();
      }
    )
  );
}

export function unsubscribe(name) {
  eventGetterSafe(name).unsubscribe();
}

export function unsubscribeAll(prefix) {
  each(subscriptions, (subscription, key) => {
    if (prefix && key.indexOf(prefix) < 0) {
      // don't remove if prefix does not match
      noop();
    } else {
      // remove when prefix match or no prefix provided
      subscription.unsubscribe();
      delete subscriptions[key];
    }
  });
}

export function next(name, ...rest) {
  const event = eventGetterSafe(name);
  if (typeof event.next === 'function') {
    event.next(rest);
  }
}

export function subscriptionExist(name) {
  return subscriptions[name] && !subscriptions[name].closed;
}
